module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/western_chef_female-dccc490a0165d215acdd7492b750cdef.webp";